import { useReactiveVar } from "@apollo/client";
import { localRecordingToolSession, localRecordingToolState } from "../../../../model";
import type { IRecordingToolSession } from "../../../../../logic/recordingTool/recordingToolSession";

export const useRecordingSession = () => {
    const recordingSession = useReactiveVar(localRecordingToolSession);

    const setRecordingSession = (session: IRecordingToolSession) => {
        localRecordingToolSession(session);
    };

    const clearRecordingSession = () => {
        localRecordingToolSession()?.destroy();
        localRecordingToolSession(null);
        localRecordingToolState(null);
    };

    return {
        recordingSession,
        setRecordingSession,
        clearRecordingSession
    };
};
